import { setInsertLinksTaskId, onInsertLinksDone } from '../actions/internalActions';
import { CloudFile } from 'owa-attachment-file-types';
import { showInsertLinksModalDialog } from './showInsertLinksModalDialog';
import { insertLinkIntoEditor } from './insertLinkIntoEditor';
import { LinkIdContainer } from '../schema/LinkIdContainer';
import LinkPlugin from '../plugin/LinkPlugin';
import { trace } from 'owa-trace';
import { preloadLinkData } from 'owa-link-data';

export async function insertLinks(
    files: CloudFile[],
    insertLinksTaskId: string,
    linkPlugin: LinkPlugin,
    linkIdContainer: LinkIdContainer
) {
    trace.info('insertLinks');

    // VSTO 57638: need to refactor, what about sharingDialogModule
    await preloadLinkData.import();

    setInsertLinksTaskId(insertLinksTaskId);
    showInsertLinksModalDialog();
    for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (!(await insertLinkIntoEditor(file, insertLinksTaskId, linkPlugin, linkIdContainer))) {
            return;
        }
    }

    onInsertLinksDone();
}
